module.exports = __webpack_public_path__ + "static/media/2.a0250fa0.jpg";